export enum ChatStatus {
  ONLINE = 'online',
  OFFLINE = 'offline',
  BUSY = 'busy'
}
